// @copyright  2025 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/accounting/accrued-revenues',
        component: () =>
            import('@/pages/[organisation]/accounting/accrued-revenues.vue'),
        name: 'accounting.accrued-revenues.search-accrued-revenues',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.accrued-revenue.view-accrued-revenues',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/accounting/accrued-revenues/new.vue'),
                name: 'accounting.accrued-revenues.create-accrued-revenue',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.accrued-revenue.create-accrued-revenue',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/accrued-revenues/[id].vue'),
                name: 'accounting.accrued-revenues.view-accrued-revenue',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.accrued-revenue.view-accrued-revenues',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/accounting/accrued-revenues/[id]/edit.vue'),
                name: 'accounting.accrued-revenues.update-accrued-revenue',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.accrued-revenue.update-accrued-revenue',
                },
            },
        ],
    },
];
